export default __webpack_public_path__ + "static/media/cardReceive.92639171.svg";